import React, { useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import ZipInputField from '../../../zip-input-field';
import { statesAndProvincesGrouping } from '../../../utility/state-dropdown';
import TextField from '../../../text-field';
import { useTranslation } from '../../../../hooks/useTranslation';
import { FormState } from '../../../../hooks/useFormState.types';
import { EnergyConsultationFormModel } from '../../types';

type FullServiceAddressProps = {
  form: FormState<EnergyConsultationFormModel>;
};

const FullServiceAddress = ({ form }: FullServiceAddressProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <TextField
          name={'serviceAddress'}
          label={t('STREET_ADDRESS')}
          style={{ width: '100%', marginTop: 20 }}
          inputProps={{
            maxLength: 60,
          }}
          {...form.props('serviceAddress')}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          name={'city'}
          label={t('CITY')}
          style={{ width: '100%' }}
          inputProps={{
            maxLength: 20,
          }}
          {...form.props('city')}
        />
      </Grid>
      <Grid item xs={6} md={6}>
        <FormControl
          error={Boolean(form.errors.state)}
          style={{ width: '100%', background: 'transparent' }}
          variant="outlined"
        >
          <InputLabel id="id-sub-type-state-label">{t('STATE')}</InputLabel>
          <Select
            labelId="id-sub-type-state-label"
            name="state"
            inputProps={{
              'data-testid': 'state-field',
              style: { background: '#FFF' },
            }}
            value={form.values.state}
            error={Boolean(form.errors.state)}
            autoWidth
            onBlur={form.onBlur}
            style={{ width: '100%' }}
            label={t('STATE')}
            variant="outlined"
            native
            onChange={(e: any) => {
              void form.onChange(e);
            }}
          >
            <option key={'OR'} value={'OR'}>
              {'OR'}
            </option>
            {statesAndProvincesGrouping.unitedStates
              .filter((v: string) => v !== 'OR')
              ?.map((v: string) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
          </Select>
          <FormHelperText>{form.errors.state}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <ZipInputField
          name={'postalCode'}
          label={t('ZIP_POSTAL_CODE')}
          style={{ width: '100%' }}
          inputProps={{ minLength: 1, maxLength: 5 }}
          {...form.props('postalCode')}
        />
      </Grid>
    </>
  );
};

export default FullServiceAddress;
